{
  "id": "campaign-014",
  "name": "Overgrown Garden",
  "seed": "campaign:14",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,HHH",
    ",,,,...,,HHH",
    ",,,.....,___",
    ",,,.....,,,,",
    ",,,*..,,,,,,",
    ",,*,*#,,,,,,",
    ",h,,,,,,,,,,",
    ",...,,,...,,",
    ".....,.....,",
    ".....#....g,",
    ".....,.....,",
    ",...,,....,,",
    "..x,,,...,x,",
    "S...,,...,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 14,
  "biome": "backyard",
  "par": {
    "reel": 12846,
    "push": 8029,
    "selfPropelled": 7518,
    "tractor": 4465,
    "zeroTurn": 5046,
    "fairway": 2668
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 22,
      "selfPropelled": 19,
      "tractor": 23,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
